<template>
  <div :class="$style.root">
    <div
      ref="content"
      :class="$style.content"
      tabindex="0"
      @keyup.esc="closeSelf()"
    >
      <div :class="$style.contentInner">
        <LayoutModalHeaderComponent :class="$style.header">
          <template #content>
            <slot name="heading" />
          </template>
          <template #linkToClose>
            <i18nLink :to="automaticClosePath">
              <CoreButtonsCloseComponent />
            </i18nLink>
          </template>
        </LayoutModalHeaderComponent>

        <slot />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { omit } from 'lodash-es'

const props = defineProps({
  closePath: {
    type: String,
    required: false
  }
})

const route = useRoute()
const queryObject = omit(filterRouteQuery(route.query), 'modal')
const automaticClosePath = props.closePath ? props.closePath : { path: route.path, query: queryObject }

const content = ref(null)

useHead({
  htmlAttrs: {
    'data-has-modal': ''
  }
})

onUnmounted(() => {
  document.documentElement.removeAttribute('data-has-modal')
})

onMounted(() => {
  content.value.focus()
})

const router = useRouter()
const closeSelf = () => {
  router.push(automaticClosePath)
}

onClickOutside(content, () => {
  closeSelf()
})

</script>

<style module>
.root {
  position: fixed;
  z-index: var(--z-index--modal);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  background-color: var(--color--background);
}

.content {
  composes: container--modal from global;
}

.content:focus {
  outline: none;
}

.contentInner {
  padding: var(--unit--default);
  padding-top: 0;

  background-color: var(--color--background);
  color: var(--color--primary);

  overflow-x: scroll;
  max-height: var(--100svh);
}

.header {
  padding-top: var(--unit--default);
  padding-left: 0;
  padding-right: 0;
}
</style>
